export default __webpack_public_path__ + "54207d724e37b13f0072cb38f4f724a8.jpg";